import React from 'react';

const Result = (props) => {    

    return ( 
        <div className="resultado">
           <h2>Resultado</h2>
           <p>El precio es {props.price}</p>
        </div>
     );
}
 
export default Result;